import { render, staticRenderFns } from "./HomepageBody.vue?vue&type=template&id=b6800d90"
import script from "./HomepageBody.vue?vue&type=script&lang=js"
export * from "./HomepageBody.vue?vue&type=script&lang=js"
import style0 from "./HomepageBody.vue?vue&type=style&index=0&id=b6800d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports